import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(timezone)
export const appInfoObject = {
  duration: Date.now()
}

export function getRiskInfo() {
  return {
    referer: window.location.href,
    cookie_enabled: navigator.cookieEnabled,
    screen_width: window.screen.width,
    screen_height: window.screen.height,
    browser_language: navigator.language,
    browser_platform: navigator.platform,
    browser_name: navigator.appCodeName,
    browser_version: navigator.appVersion,
    browser_online: navigator.onLine,
    timezone_name: dayjs.tz.guess(),
    user_agent: navigator.userAgent
  }
}

export enum RiskInfoDecision {
  PASS = 'PASS',
  REJECT = 'BLOCK-reject',
  SEND_CODE = 'BLOCK-send_code',
  TIMEOUT = 'Timeout'
}
